import React from 'react';
import { BringzzText } from "@bringzz/components";

const getRandomColor = (letter) => {
  // Predefined colors for consistency based on letter
  const colors = [
    'bg-purple-500', 'bg-blue-500', 'bg-green-500', 
    'bg-yellow-500', 'bg-red-500', 'bg-pink-500',
    'bg-indigo-500', 'bg-teal-500'
  ];
  
  // Use the letter's charCode to consistently pick a color
  const index = letter.charCodeAt(0) % colors.length;
  return colors[index];
};

const LetterAvatar = ({ 
  name, 
  size = 'h-24 w-24',
  fontSize = 'text-4xl',
  className = '' 
}) => {
  const letter = name ? name.charAt(0).toUpperCase() : '?';
  const bgColor = getRandomColor(letter);

  return (
    <div 
      className={`
        ${size} 
        ${bgColor} 
        rounded-full 
        flex 
        items-center 
        justify-center 
        text-white 
        font-bold 
        ${fontSize}
        ${className}
      `}
    >
      {letter}
    </div>
  );
};

export default LetterAvatar; 